<template>
  <el-space :direction="direction" alignment="left" :size="6">
    <div v-if="show.indexOf('hide') > -1">
      <el-button v-if="rowData.isDel==1" type="success" :size="size" v-loading="rowData.delLoading" @click="updateResumeDelState(rowData, 0, '取消隐藏')">取消隐藏</el-button>
      <el-button v-if="rowData.isDel==0" type="primary" :size="size" v-loading="rowData.delLoading" @click="updateResumeDelState(rowData, 1, '隐藏')">隐藏</el-button>
    </div>
    <div v-if="show.indexOf('cancel') > -1">
      <el-button v-if="rowData.isDel==2" type="success" :size="size" v-loading="rowData.delLoading" @click="updateResumeDelState(rowData, 0, '取消注销')">取消注销</el-button>
      <el-button v-if="rowData.isDel==0 || rowData.isDel==1" type="primary" :size="size" v-loading="rowData._delLoading" @click="updateResumeDelState(rowData, 2, '注销')">注销</el-button>
    </div>
    <div v-if="show.indexOf('forbidden') > -1">
      <el-button v-if="!rowData.isForbidden" type="primary" :size="size" @click="updateUserForbidden( rowData, 1)" v-loading="rowData['forbiddenLoading']">封号</el-button>
      <el-button v-if="rowData.isForbidden" type="success" :size="size" @click="updateUserForbidden(rowData, 0)" v-loading="rowData['forbiddenLoading']">解除封号</el-button>
    </div>
    <div v-if="show.indexOf('abnormal') > -1">
      <el-button v-if="!rowData.isAbnormal" type="primary" :size="size" @click="updateAbnormal(rowData, 1)" v-loading="rowData['_forbiddenLoading']">标记异常</el-button>
      <el-button v-if="rowData.isAbnormal" type="success" :size="size" @click="updateAbnormal(rowData, 0)" v-loading="rowData['_forbiddenLoading']">取消异常</el-button>
    </div>
    <div v-if="show.indexOf('idfa') > -1">
      <el-button v-if="!rowData.isIdfaBan" type="primary" :size="size" @click="updateUserIdfaBan(rowData, 0)" v-loading="rowData['isIdfaBanLoading']">冻结设备</el-button>
      <el-button v-if="rowData.isIdfaBan" type="success" :size="size" @click="updateUserIdfaBan(rowData, 1)" v-loading="rowData['isIdfaBanLoading']">解除冻结</el-button>
    </div>
    <div v-if="show.indexOf('chat') > -1">
      <el-button v-if="rowData.isBannedChat" type="success" :size="size" @click="updateBannedChat(rowData, 2)" v-loading="rowData['bannedLoading']">解除禁言</el-button>
      <el-button v-if="!rowData.isBannedChat" type="primary" :size="size" @click="updateBannedChat(rowData, 1)">禁言</el-button>
    </div>
    <div v-if="show.indexOf('screen') > -1">
      <el-button v-if="rowData.screenState == 0" type="primary" :size="size" @click="updateScreenState(rowData, 1)" v-loading="rowData['screenLoading']">屏蔽</el-button>
      <el-button v-if="rowData.screenState == 1" type="success" :size="size" @click="updateScreenState(rowData, 0)" v-loading="rowData['screenLoading']">取消屏蔽</el-button>
    </div>
    <AppointAuth v-if="show.indexOf('point') > -1" :row="rowData" :userId="userId" />
    <div v-if="show.indexOf('quality') > -1">
      <el-button v-if="rowData.qualityState == 0" type="primary" :size="size" @click="updateQualityState(rowData, 1)" v-loading="rowData['qualityLoading']">优质用户</el-button>
      <el-button v-if="rowData.qualityState == 1" type="success" :size="size" @click="updateQualityState(rowData, 0)" v-loading="rowData['qualityLoading']">非优质用户</el-button>
    </div>
    <div v-if="show.indexOf('homeMatch') > -1">
      <el-button v-if="rowData.userSetting.homeMatch == 1" type="primary" :size="size" @click="updateHomeMatch(rowData, 0)" v-loading="rowData['macthLoading']">推荐中</el-button>
      <el-button v-if="rowData.userSetting.homeMatch == 0" type="danger" :size="size" @click="updateHomeMatch(rowData, 1)" v-loading="rowData['macthLoading']">不推荐</el-button>
    </div>
    <div v-if="show.indexOf('focus') > -1">
      <el-button v-if="rowData.focusState > 3" type="danger" :size="size" @click="updateFocusState(rowData, 3)" v-loading="rowData['focusLoading']">取消关注</el-button>
      <el-button v-if="rowData.focusState <= 3" type="primary" :size="size" @click="updateFocusState(rowData, 5)" v-loading="rowData['focusLoading']">设为关注</el-button>
    </div>
  </el-space>
</template>

<script>
import {postFormData} from "@/api/api";
import {
  updateResumeDelState,
  updateScreenState,
  updateUserBannedChat,
  updateUserForbidden,
  updateForbiddenState,
  updateAbnormalState,
  updateUserIdfaBan,
  updateResumeQualityState,
  updateResumeUserSetting,
  updateResumeFocusState
} from "@/api/url";
import Dialog from "@/assets/js/dialog";
import ForbiddenDialog from "@/components/resume/ForbiddenDialog";
import BannedChatDialog from "@/components/resume/BannedChatDialog";
import AppointAuth from "@/components/resume/AppointAuth";

export default {
  components:{ AppointAuth },
  name: "ActionButton",
  props: {
    row: {
      type: Object,
      default: () => {
        return {}
      }
    },
    userId: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small',
    },
    direction: {
      type: String,
      default: 'vertical',
    },
    showList: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      rowData: this.row
    }
  },
  watch: {
    row() {
      this.rowData = this.row
    }
  },
  computed: {
    show() {
      return this.showList.split(',')
    }
  },
  methods: {

    //展示、隐藏、注销
    updateResumeDelState(row, state, type) {
      this.$confirm('确认' + type + '用户【' + row.nickName + '】简历？').then(() => {
        if(state == 2) {
          row['_delLoading'] = true
        } else {
          row['delLoading'] = true
        }
        let param = {};
        param['id'] = this.userId?this.userId:row.userId;
        param['del'] = state;
        let _this = this;
        postFormData(updateResumeDelState, param).then(function(data) {
          let code = data.code;
          let msg = data.msg;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            row['isDel'] = state;
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          row['delLoading'] = false;
          row['_delLoading'] = false;
        })
            .catch(function(response) {
              row['delLoading'] = false;
              row['_delLoading'] = false;
            })
      })
    },

    //更新封号
    updateUserForbidden(row, state) {
      let arr = []
      arr.push(this.userId?this.userId:row.userId)
      if(state == 1) {
        Dialog.open({
          title: '确定对用户【' + row.nickName + '】封号？',
          component: ForbiddenDialog,
          data: {
            idArray: arr,
            width: '500px'
          },
          confirm: () => {
            row['isForbidden'] = true
          }
        })
      } else if(state == 0) {
        this.$confirm('确定【取消封号】用户' +'【' + row.nickName + '】?').then(()=>{
          row['forbiddenLoading'] = true
          let param = {}
          param['idArr'] = arr
          param['forbiddenState'] = state
          param['idfaBanState'] = 0
          postFormData(updateForbiddenState, param).then((data)=>{
            let {code, msg} = data
            if(code == 200) {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              })
              row['isForbidden'] = false
            }else {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            row['forbiddenLoading'] = false
          }).catch(()=>{
            row['forbiddenLoading'] = false
          })
        })
      }
    },

    //标记异常
    updateAbnormal(row, state) {
      this.$confirm('确定' + (state == 1?'标记异常':'取消标记异常') + '用户' +'【' + row.nickName + '】?').then(()=>{
        row['_forbiddenLoading'] = true
        let param = {}
        param['id'] = this.userId?this.userId:row.userId
        param['abnormalState'] = state
        postFormData(updateAbnormalState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row['isAbnormal'] = state == 1?true:false
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row['_forbiddenLoading'] = false
        }).catch(()=>{
          row['_forbiddenLoading'] = false
        })
      })
    },

    //冻结设备
    updateUserIdfaBan(row, state) {
      this.$confirm('确定' + (state == 0?'冻结':'解冻') + '用户' +'【' + row.nickName + '】的设备?').then(()=>{
        row['isIdfaBanLoading'] = true
        let param = {}
        param['id'] = this.userId?this.userId:row.userId
        param['state'] = state
        postFormData(updateUserIdfaBan, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row['isIdfaBan'] = state == 0?true:false
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row['isIdfaBanLoading'] = false
        }).catch(()=>{
          row['isIdfaBanLoading'] = false
        })
      })
    },

    //单个禁言/解除
    updateBannedChat(row, state) {
      let userIdArr = [];
      userIdArr.push(this.userId?this.userId:row.userId);
      if(state == 1) {
        Dialog.open({
          title: '禁言时间',
          component: BannedChatDialog,
          data: {
            userIdArray: userIdArr,
            width: '500px'
          },
          confirm: () => {
            row['isBannedChat'] = true
          }
        })
      }else if (state == 2) {
        this.$confirm('确定对用户【'+ row.nickName + '】解除禁言？')
            .then(() => {
              row['bannedLoading'] = true
              let param = {}
              param['idArr'] = userIdArr
              param['state'] = 2
              param['day'] = 0
              postFormData(updateUserBannedChat, param).then((data) => {
                let {code, msg} = data;
                if ( code == 200 ) {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'success'
                  })
                  row['isBannedChat'] = 0
                } else {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'warning'
                  })
                }
                row['bannedLoading'] = false
              }).catch(()=>{
                row['bannedLoading'] = false
              })
            })
            .catch(() => {
              // catch error
            })
      }
    },

    //更新屏蔽状态
    updateScreenState(row, state) {
      this.$confirm('确定' + (state==1?'【屏蔽】用户':'【取消屏蔽】用户') +'【' + row.nickName + '】?').then(()=>{
        row['screenLoading'] = true
        let param = {}
        param['id'] = this.userId?this.userId:row.userId
        param['screenState'] = state
        postFormData(updateScreenState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row['screenState'] = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row['screenLoading'] = false
        }).catch(()=>{
          row['screenLoading'] = false
        })
      })
    },

    //优质用户
    updateQualityState(row, state) {
      this.$confirm('确定设置' +'【' + row.nickName + '】为' + (state==1?'优质用户':'非优质用户') + '?').then(()=>{
        row['qualityLoading'] = true
        let param = {}
        param['id'] = this.userId?this.userId:row.userId
        param['qualityState'] = state
        postFormData(updateResumeQualityState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row['qualityState'] = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row['qualityLoading'] = false
        }).catch(()=>{
          row['qualityLoading'] = false
        })
      })
    },

//首页推荐
    updateHomeMatch(row, state) {
      this.$confirm('确定设置' +'【' + row.nickName + '】为' + (state==1?'推荐用户':'不推荐用户') + '?').then(()=>{
        row['macthLoading'] = true
        let param = {}
        param['id'] = this.userId?this.userId:row.userId
        param['homeMatch'] = state
        postFormData(updateResumeUserSetting, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row.userSetting.homeMatch = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row['macthLoading'] = false
        }).catch(()=>{
          row['macthLoading'] = false
        })
      })
    },


    //设为关注
    updateFocusState(row, state) {
      this.$confirm('确定设置' +'【' + row.nickName + '】为' + (state==5?'关注用户':'不关注用户') + '?').then(()=>{
        row['focusLoading'] = true
        let userIdArr = [];
        userIdArr.push(this.userId?this.userId:row.userId);
        let param = {}
        param['idArr'] = userIdArr
        param['focusState'] = state
        postFormData(updateResumeFocusState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row.focusState = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row['focusLoading'] = false
        }).catch(()=>{
          row['focusLoading'] = false
        })
      })
    },

  }
}
</script>

<style scoped>

</style>
